import { render, staticRenderFns } from "./ModifyCx3RecordingPackageModal.vue?vue&type=template&id=048e58aa&"
import script from "./ModifyCx3RecordingPackageModal.vue?vue&type=script&lang=js&"
export * from "./ModifyCx3RecordingPackageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports